module.exports = __webpack_public_path__ + "img/flowers2.432c75e2.jpg";